import FatturazioneStrutture from "../";

const routes = [
    { name: "ContabilitaFatturazioneList", path: "/contabilita/fatturazionestrutture", component: FatturazioneStrutture.ContabilitaFatturazioneStruttureDocumentiList, meta: { title: "Fatturazione" } },
];

export default routes;
